import {
  DropdownOption,
  FieldBase,
  FieldBaseParam,
} from '@shared/components/dynamic-form/models/field-base';

export class FieldDropdown extends FieldBase<DropdownOption> {
  override controlType = 'dropdown';

  options: DropdownOption[] = [];

  constructor(
    params: FieldBaseParam<DropdownOption> = {},
    options?: DropdownOption[]
  ) {
    super(params);

    this.options = options ?? [];
  }
}
